import React from "react"
import LogisticaHome from "../components/Logistica/LogisticaHome"

export default function Logistica() {
    return <LogisticaHome />
}
